/* eslint-disable no-unreachable */
import DeleteIcon from '@mui/icons-material/Delete';
import {Button, Divider, IconButton, Stack, TextField, Typography} from '@mui/material';
import useVisible from 'src/hooks/useVisible';
import {calcPriceAfterDiscount} from 'src/utils/discountUtils';
import {isNullOrEmpty} from 'src/utils/helperMethods';
import {getImageSrc} from 'src/utils/productUtils';
import {getSiteCurrency} from 'src/utils/selectors';
import ProductsGridSelection from '../products/common/ProductsGridSelection/ProductsGridSelection';
import ResponsiveDialog from 'src/components/modals/ResponsiveDiaog';
import CartItem from './CartItem.item';
import SimpleCartItem from './SimpleCartItem.item';
import {isFeatureAllowed} from 'src/utils/featureUtils';

export default function CartItemSelector({
	title,
	handleItemQuantityChange,
	checkAddedItemExists,
	handleAddItem,
	handleRemoveItemByProductId,
	handleRemoveItem,
	handleItemChange,
	addedProducts,
	resetSelections,
	defaultVisibility = false,
	showBranch = false,
	branch,
	simpleProducts = [],
	setSimpleProducts,
}) {
	const {isVisible, show, hide, toggle, setIsVisible} = useVisible(defaultVisibility);

	const handleAddSimpleItem = async () => {
		const newSimpleProduct = {
			id: `simple-${Date.now()}`,
			name: '',
			price: '',
			discount: 0,
			selectedQuantity: 1,
			simple: true,
		};
		setSimpleProducts([...simpleProducts, newSimpleProduct]);
	};

	const allow_simple_products = isFeatureAllowed('simple_products');

	return (
		<>
			{/* Selection title with button to select */}
			<Stack spacing={1} direction="row" justifyContent="space-between">
				<Typography variant="subtitle2">{title}</Typography>
				<Button onClick={show}>تحديد</Button>
			</Stack>

			{/* UI to let user select items when no items selected */}
			{isNullOrEmpty(addedProducts) && (
				<Stack justifyContent="center" alignItems="center">
					<img src="/static/illustrations/items-selection.png" height={100} />
					<Button onClick={show} variant="text">
						{title}
					</Button>
				</Stack>
			)}

			{/* Cart Item list */}
			<Stack my={1} spacing={1}>
				<Stack mt={2} spacing={2}>
					{addedProducts.map((item) => {
						return (
							<CartItem
								handleItemChange={handleItemChange}
								handleItemQuantityChange={handleItemQuantityChange}
								handleRemoveItem={handleRemoveItem}
								item={item}
								key={item.id}
								showBranch={showBranch}
								branch={branch}
							/>
						);
					})}
					{allow_simple_products && (
						<Stack alignItems="center">
							{simpleProducts.length === 0 && addedProducts.length === 0 && <span>او</span>}
							{simpleProducts.length === 0 && (
								<Button type="button" sx={{color: 'gray'}} onClick={handleAddSimpleItem}>
									إضافة منتج بسيط
								</Button>
							)}
						</Stack>
					)}

					{simpleProducts.length > 0 && (
						<Stack
							id="simple-products"
							direction="row"
							alignItems="center"
							spacing={2}
							justifyContent={'space-between'}
						>
							<Typography variant="subtitle2">المنتجات البسيطة</Typography>

							<Button type="button" onClick={handleAddSimpleItem}>
								إضافة
							</Button>
						</Stack>
					)}
					{simpleProducts.map((item, index) => {
						return (
							<SimpleCartItem
								handleItemChange={(id, changes) =>
									setSimpleProducts(simpleProducts.map((p) => (p.id == item.id ? {...p, ...changes} : p)))
								}
								handleItemQuantityChange={() =>
									setSimpleProducts(
										simpleProducts.map((p) =>
											p.id === item.id ? {...p, selectedQuantity: p.selectedQuantity + 1} : p,
										),
									)
								}
								handleRemoveItem={() => setSimpleProducts(simpleProducts.filter((p) => p.id !== item.id))}
								item={item}
								key={item.id}
							/>
						);
					})}
				</Stack>
			</Stack>

			{/* Item selection modal */}
			<ResponsiveDialog
				maxWidth="md"
				open={isVisible}
				setOpen={setIsVisible}
				actions={
					<Button sx={{py: 1.1}} fullWidth onClick={() => hide()} variant="contained">
						تأكيد
					</Button>
				}
			>
				<ProductsGridSelection
					columns={{xl: 3}}
					handleItemQuantityChange={handleItemQuantityChange}
					checkAddedItemExists={checkAddedItemExists}
					handleAddItem={handleAddItem}
					handleRemoveItem={handleRemoveItem}
					handleRemoveItemByProductId={handleRemoveItemByProductId}
					addedProducts={addedProducts}
					resetSelections={resetSelections}
				/>
			</ResponsiveDialog>
		</>
	);
}
